import { render, staticRenderFns } from "./CoursesAndInstructorsDesktop.vue?vue&type=template&id=6e9f244e&scoped=true"
import script from "./CoursesAndInstructorsDesktop.vue?vue&type=script&lang=js"
export * from "./CoursesAndInstructorsDesktop.vue?vue&type=script&lang=js"
import style0 from "./CoursesAndInstructorsDesktop.vue?vue&type=style&index=0&id=6e9f244e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e9f244e",
  null
  
)

export default component.exports